import { CODES_KIND_PARAM, CodesKind } from "shared/constants";
import { useSearchParams } from "~/hooks/useSearchParams";

/** Writes re-set `kind` so a search pins the kind even when the URL had none. */
export const useCodesQueryParam = (kind: CodesKind) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const submittedQuery = searchParams.get("q")?.trim() ?? "";

  const setSubmittedQuery = (query: string) => {
    const trimmedQuery = query.trim();
    setSearchParams(
      (params) => {
        params.set(CODES_KIND_PARAM, kind);
        if (trimmedQuery) {
          params.set("q", trimmedQuery);
        } else {
          params.delete("q");
        }
        return params;
      },
      { replace: true },
    );
  };

  return { submittedQuery, setSubmittedQuery };
};
